import React from 'react';
import { SantuarioLanding } from './pages/SantuarioLanding';
export function App() {
  return <SantuarioLanding data-id="element-0" />;
}